import DataTable from "react-data-table-component";

const columns = [
    {
        name: "Property ID",
        selector: (row) => row.propertyId,
    },
    {
        name: "Property Name",
        selector: (row) => row.propertyData.name,
    },
    {
        name: "Amount",
        selector: (row) => "$" + row.amount,
    },
    {
        name: "EMI Date",
        selector: (row) => row.emi_date,
    },
];

const InvestmentTable = (props) => {
  return (

    
    <div className="card p-3" style={{overflowX: 'auto'}}>
      <table style={{width: '100%'}}>
        <thead>
          <tr>
            <th>Year</th>
            <th>Total Savings</th>
            <th>Interest (Year)</th>
            <th>Total Interest</th>
            <th>Invested Capital</th>
          </tr>
        </thead>
        <tbody>
          {/* <tr>
            <td>YEAR NUMBER</td>
            <td>TOTAL SAVINGS END OF YEAR</td>
            <td>INTEREST GAINED IN YEAR</td>
            <td>TOTAL INTEREST GAINED</td>
            <td>TOTAL INVESTED CAPITAL</td>
          </tr> */}

          {props.data.map((item) => {
            const formatter = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });

            return (
              <tr key={item.year}>
                <td>{item.year}</td>
                <td>{formatter.format(item.savingsEndOfYear)}</td>
                <td>{formatter.format(item.yearlyInterest)}</td>
                <td>
                  {formatter.format(
                    item.savingsEndOfYear -
                      props.initialInvestment -
                      item.yearlyContribution * item.year
                  )}
                </td>
                <td>
                  {formatter.format(
                    props.initialInvestment +
                      item.yearlyContribution * item.year
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default InvestmentTable;
